export class UpdatePharmacyError extends Error {
  public constructor() {
    super('Sorry, there was a problem updating the pharmacy. Please select another or try again.');
  }
}
